import { pushWeboramaAnalytics } from 'store/common/page/analytics';

export const onLoadPageLayout = () => () => {
  pushWeboramaAnalytics();
};
